import { Box, LinearProgress, Typography } from '@mui/material';
import { CK, FONT_BODY } from '../portalStyles';

// percent: 0..100 for a determinate bar, or null/undefined/<0 for indeterminate.
export default function OperationProgress({ percent, label, sx }) {
  const indeterminate = percent == null || percent < 0;
  const value = indeterminate ? undefined : Math.max(0, Math.min(100, percent));
  return (
    <Box sx={{ mb: 2, ...sx }}>
      {label && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'space-between',
            gap: 1,
            mb: 0.75,
          }}
        >
          <Typography
            sx={{ fontFamily: FONT_BODY, fontSize: '0.8rem', color: CK.body, minWidth: 0 }}
          >
            {label}
          </Typography>
          {!indeterminate && (
            <Typography
              sx={{
                fontFamily: FONT_BODY,
                fontSize: '0.8rem',
                fontWeight: 600,
                color: CK.navy,
                flexShrink: 0,
              }}
            >
              {Math.round(value)}%
            </Typography>
          )}
        </Box>
      )}
      <LinearProgress
        variant={indeterminate ? 'indeterminate' : 'determinate'}
        value={value}
        sx={{
          height: 6,
          borderRadius: 3,
          backgroundColor: CK.border,
          '& .MuiLinearProgress-bar': { borderRadius: 3, backgroundColor: CK.blue },
        }}
      />
    </Box>
  );
}
